import { Directive } from '@angular/core';


@Directive({
    selector: 'select2-hint',
    standalone: false
})
export class Select2Hint {}
